 <template>
  <v-layout row wrap>
    <v-flex>
      <v-card class="pa-2" v-if="showCommPVList">
        <v-card-title class="grey lighten-2">
          Commission Payment Voucher List
          <v-spacer></v-spacer>
          <v-btn text icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12 class="mt-3">
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs12>
            <v-card>
              <!--Search Results-->
              <v-flex xs12>
                <v-data-table
                  v-bind:headers="commPVColumns"
                  v-bind:items="itemsCommPV"
                  :footer-props="{'items-per-page-options': itemsPerPage }"
                  v-bind:options.sync="paginationCommPV"
                  item-key="key"
                  :loading="loading"
                  :no-data-text="noDataText"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectedCommPVColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action :rowData="row" query @query="doCommPVQuery(row)"></table-action>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
      <v-card class="pa-2" v-if="showCommPVDetail">
        <v-card-title class="headline grey lighten-2" primary-title>
          Commssion Details
          <v-spacer></v-spacer>
          <v-btn text icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <v-text-field :label="comVoucherLabel.comType" v-model="comVoucherDet.comType" readonly hide-details></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.voucherNo }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.voucherNo }}</span>
                </v-flex>
                <v-flex md4 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.comPayRecover }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.comPayRecover }}</span>
                </v-flex>
                <v-flex md4 xs12> </v-flex>
                <v-flex md4 xs12>
                  <v-checkbox color="primary" :label="comVoucherLabel.comDel" v-model="comVoucherDet.comDel" readonly hide-details></v-checkbox>
                </v-flex>
                <v-flex md12 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.comMatchedBy }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.comMatchedBy }}</span>
                </v-flex>
                <v-flex md6 xs12>
                  <div>{{ comVoucherLabel.billAcct }}</div>
                </v-flex>
                <v-flex md6 xs12>
                  <div>{{ comVoucherLabel.overAcct }}</div>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.bAcctNo }}</v-subheader>
                  <div class="queryValue" v-for="item in filterbAcctNoList" :key="item.label">{{ item.label }}</div>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.oAcctNo }}</v-subheader>
                  <div class="queryValue" v-for="item in filteroAcctNoList" :key="item.label">{{ item.label }}</div>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.bBranch }}</v-subheader>
                  <div class="queryValue" v-for="item in filterbBranchList" :key="item.label">{{ item.label }}</div>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.oBranch }}</v-subheader>
                  <div class="queryValue" v-for="item in filteroBranchList" :key="item.label">{{ item.label }}</div>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.bTranType }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.bTranType }}</span>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.oTranType }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.oTranType }}</span>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.bDocNo }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.bDocNo }}</span>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.oDocNo }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.oDocNo }}</span>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.bFund }}</v-subheader>
                  <div class="queryValue" v-for="item in filterbFundList" :key="item.label">{{ item.label }}</div>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.oFund }}</v-subheader>
                  <div class="queryValue" v-for="item in filteroFundList" :key="item.label">{{ item.label }}</div>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.bSuffix }}</v-subheader>
                  <div class="queryValue" v-for="item in filterbSuffixList" :key="item.label">{{ item.label }}</div>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.oSuffix }}</v-subheader>
                  <div class="queryValue" v-for="item in filteroSuffixList" :key="item.label">{{ item.label }}</div>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.bComm }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.bComm }}</span>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.oComm }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.oComm }}</span>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.bOutStdBal }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.bOutStdBal }}</span>
                </v-flex>
                <v-flex md6 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.oOutStdBal }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.oOutStdBal }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex xs12>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-content class="grey lighten-5">
                  <template v-slot:header>
                    <div class="v-icon mdi mdi-plus theme--light d-flex">
                      <span class="headerTitle">Other Details</span>
                    </div>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-flex xs12>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-subheader class="queryLabel">{{ comVoucherLabel.polNo }}</v-subheader>
                              <span class="queryValue">{{ comVoucherDet.polNo }}</span>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-subheader class="queryLabel">{{ comVoucherLabel.lastMatchedDate }}</v-subheader>
                              <span class="queryValue">{{ comVoucherDet.lastMatchedDate }}</span>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-subheader class="queryLabel">{{ comVoucherLabel.tranDate }}</v-subheader>
                              <span class="queryValue">{{ comVoucherDet.tranDate }}</span>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-subheader class="queryLabel">{{ comVoucherLabel.prem }}</v-subheader>
                              <span class="queryValue">{{ comVoucherDet.prem }}</span>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-subheader class="queryLabel">{{ comVoucherLabel.netAmt }}</v-subheader>
                              <span class="queryValue">{{ comVoucherDet.netAmt }}</span>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-text-field
                                :label="comVoucherLabel.insRefNoName"
                                v-model="comVoucherDet.insRefNoName"
                                readonly
                                hide-details
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-flex>
          <v-flex xs12>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex md12 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.createdBy }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.createdBy }}</span>
                </v-flex>
                <v-flex md12 xs12>
                  <v-subheader class="queryLabel">{{ comVoucherLabel.modifiedBy }}</v-subheader>
                  <span class="queryValue">{{ comVoucherDet.modifiedBy }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex xs12 right>
            <div>
              <v-btn color="primary" @click=";(showCommPVDetail = false), (showCommPVList = true)">
                Back to List
                <v-icon right>mdi-view-list</v-icon>
              </v-btn>
            </div>
            <v-spacer></v-spacer>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import { accountsFilters } from '@/mixins/accounting/accountsFilters'
import { accountsViewMixin } from '@/mixins/accounting/accountsViewMixin'

export default {
  data() {
    return {
      showCommPVList: true,
      showCommPVDetail: false,
      comVoucherLabel: {
        comType: 'Commission Type',
        voucherNo: 'Voucher No.',
        comPayRecover: 'Commission Payable / Recover',
        comDel: 'Commission Deleted',
        comMatchedBy: 'Commission Matched By',
        billAcct: 'Billing Account',
        overAcct: 'Overriding Account',
        bAcctNo: 'Account',
        oAcctNo: 'Account',
        bBranch: 'Branch',
        oBranch: 'Branch',
        bTranType: 'Transaction Type',
        oTranType: 'Transaction Type',
        bDocNo: 'Document No.',
        oDocNo: 'Document No.',
        bFund: 'Fund',
        oFund: 'Fund',
        bSuffix: 'Suffix',
        oSuffix: 'Suffix',
        bComm: 'Commission',
        oComm: 'Commission',
        bOutStdBal: 'Outstanding Balance',
        oOutStdBal: 'Outstanding Balance',
        createdBy: 'CreatedBy',
        modifiedBy: 'ModifiedBy',
        polNo: 'Policy No.',
        curr: 'Currency',
        lastMatchedDate: 'Last Matched Date',
        tranDate: 'Transaction Date',
        prem: 'Premium',
        netAmt: 'Net Amount',
        insRefNoName: 'Insured Reference and Name'
      },
      totalItemsCommPV: 0,
      selectedPageCommPV: 0,
      selectedCommPVColumns: ['cmType', 'cmVoucher', 'cmBilAcctNo', 'cmBilDocNo', 'cmOverAcctNo', 'cmOverDocNo', 'cmPaidDate'],
      commPVColm: [
        { text: 'Type', value: 'cmType' },
        { text: 'Voucher', value: 'cmVoucher' },
        { text: 'Bill Acct No.', value: 'cmBilAcctNo' },
        { text: 'Bill Doc No.', value: 'cmBilDocNo' },
        { text: 'Overriding Acct No.', value: 'cmOverAcctNo' },
        { text: 'Overriding Doc No. ', value: 'cmOverDocNo' },
        { text: 'Paid Date', value: 'cmPaidDate' }
      ],
      paginationCommPV: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {},
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    doCommPVQuery(data) {
      this.fetchCommPVData(data.item).then((result) => {
        this.showCommPVList = false
        this.showCommPVDetail = true
      })
    }
  },
  computed: {
    commPVColumns() {
      let result = []
      for (const selectedCommPVColumns of this.selectedCommPVColumns) {
        let findCol = this.commPVColm.find((a) => selectedCommPVColumns === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    filterbAcctNoList() {
      return this.accountnos.filter((list) => {
        return list.value === this.comVoucherDet.bAcctNo
      })
    },
    filteroAcctNoList() {
      return this.accountnos.filter((list) => {
        return list.value === this.comVoucherDet.oAcctNo
      })
    },
    filterbBranchList() {
      return this.allbranches.filter((list) => {
        return list.value === this.comVoucherDet.bBranch
      })
    },
    filteroBranchList() {
      return this.allbranches.filter((list) => {
        return list.value === this.comVoucherDet.oBranch
      })
    },
    filterbFundList() {
      return this.funds.filter((list) => {
        return list.value === this.comVoucherDet.bFund
      })
    },
    filteroFundList() {
      return this.funds.filter((list) => {
        return list.value === this.comVoucherDet.oFund
      })
    },
    filterbSuffixList() {
      return this.acctnosuffixes.filter((list) => {
        return list.value === this.comVoucherDet.bSuffix
      })
    },
    filteroSuffixList() {
      return this.acctnosuffixes.filter((list) => {
        return list.value === this.comVoucherDet.oSuffix
      })
    }
  },
  mixins: [TableConst.default, accountsAjaxCalls, accountsFilters, accountsViewMixin],
  props: {
    itemsCommPV: {
      type: Array,
      default: null
    },
    accountnos: {
      type: Array,
      default: null
    },
    allbranches: {
      type: Array,
      default: null
    },
    funds: {
      type: Array,
      default: null
    },
    acctnosuffixes: {
      type: Array,
      default: null
    }
  }
}
</script>
